export const arrayView = (startNum, endNum) => {
  let array = [];
  for (let index = startNum; index < endNum + 1; index++) {
    array.push(index);
  }
  return array;
};
